'use client';

import { useEffect, useState } from 'react';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { MUSO, REGISTRATION_FEE } from '@/config/pricing';
import { capture } from '@/config/captureUserEvent';
import { EventNames } from '@/config/eventNames';

/** PostHog flag `heroprice`. Kill switch: set its rollout to 0%. */
const FLAG = 'heroprice';

/**
 * The upfront price under the trial button. Price is the first thing leads
 * ask, and most tap the hero button before scrolling to the FAQ. No per-week
 * or per-lesson figure: next to the button it invites a comparison with
 * cheaper per-lesson studios before the visitor has seen what is included.
 *
 * Shown unless the flag reads false, so the static page never flickers it in.
 * PostHog omits an inactive flag (undefined), so disabling it does NOT hide
 * the line; a 0% rollout does.
 */
/** Matches the `sm:` breakpoint that shows the full price line. */
const priceShown = () => window.matchMedia('(min-width: 640px)').matches;

const onSeePricing = () =>
  capture(EventNames.seePricingClicked, { placement: 'hero', price_shown: priceShown() });

export function HeroPriceLine() {
  const flag = useFeatureFlagEnabled(FLAG);
  // flags persisted from a past visit are readable during hydration; hiding
  // before mount would not match the static HTML
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (mounted && flag === false) return null;

  return (
    <p className="mt-3 max-w-md text-balance text-center text-sm text-gray-600 sm:text-start">
      Free trial first. Love it?{' '}
      {/* phones: the full price costs three lines above the fold, so it sits one tap away */}
      <span className="hidden sm:inline">
        Then it&apos;s {MUSO.quarterly} every 3 months, paid upfront, plus a one-time {REGISTRATION_FEE} registration.{' '}
      </span>
      <a href="#pricing" className="whitespace-nowrap underline" onClick={onSeePricing}>
        See pricing
      </a>
    </p>
  );
}
